import React from 'react'

export interface IWorkplaceQuizRowProps {
  title: string
  id: number
  completed: boolean
  startQuiz: (id: number) => void
}

const WorkplaceQuizRow = (props: IWorkplaceQuizRowProps) => (
  <li className={props.completed ? 'finishedModule' : ''}>
    <a
      className={'module' + props.id + ' button'}
      tabIndex={0}
      key={props.id}
      onKeyUp={(event) => {
        if (event?.keyCode == '13') {
          props.startQuiz(props.id)
        }
      }}
      onClick={() => props.startQuiz(props.id)}
      role="button"
    >
      <div>
        <span>{props.title}</span>
      </div>
    </a>
  </li>
)

export default WorkplaceQuizRow
